import { createEvent } from '@cobuildlab/react-simple-state';
import { ExperienceSubCategoryType as SubCategoryType } from '../../shared/types';

export const OnExperienceSubCategories = createEvent<SubCategoryType[]>();
export const OnExperienceSubCategoriesError = createEvent();
